module.exports = __webpack_public_path__ + "static/media/icon-venda.66596b1b.svg";